/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SmsParameterType = {
    SenderNumber: 'SENDER_NUMBER',
    Recipient: 'RECIPIENT',
    MessageValue: 'MESSAGE_VALUE',
    Extra: 'EXTRA',
    Auth: 'AUTH'
} as const;
export type SmsParameterType = typeof SmsParameterType[keyof typeof SmsParameterType];


export function instanceOfSmsParameterType(value: any): boolean {
    for (const key in SmsParameterType) {
        if (Object.prototype.hasOwnProperty.call(SmsParameterType, key)) {
            if (SmsParameterType[key as keyof typeof SmsParameterType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SmsParameterTypeFromJSON(json: any): SmsParameterType {
    return SmsParameterTypeFromJSONTyped(json, false);
}

export function SmsParameterTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SmsParameterType {
    return json as SmsParameterType;
}

export function SmsParameterTypeToJSON(value?: SmsParameterType | null): any {
    return value as any;
}

export function SmsParameterTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): SmsParameterType {
    return value as SmsParameterType;
}

